export interface IDispatchAnnualReportsFilter {
    companyName?: string;
    wildCardSearchFlag?: boolean;
    onlyWithNotes?: boolean;
}
